import React from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

const Index = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    console.log(data);
  };

  return (
    <div className="container mx-auto h-screen flex justify-center items-center w-12/12">
      <div className="md:w-4/12 w-12/12">
        <div>
          <h6 className="text-center font-bold mb-5">
            <img
              src="https://materialpro-vue3-admin.vercel.app/assets/dark-logo-icon.2f396e35.svg"
              alt="logo"
              className="mx-auto"
            />
          </h6>
          <h1 className="text-center font-bold text-2xl">Sign in</h1>
        </div>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="w-full flex flex-col justify-center items-center"
        >
          <input
            type="email"
            className="input input-bordered w-full  focus:border-gray-800 focus:border-2  focus:outline-none rounded-sm mt-5"
            placeholder="Email"
            {...register("email", {
              required: {
                message: "Email Is Required!",
              },
              pattern: /^\S+@\S+$/i,
            })}
          />
          {errors?.email?.message && (
            <p className="text-red-600 self-start">{errors.email.message}!</p>
          )}
          <input
            type="password"
            className="input input-bordered w-full  focus:border-gray-800 focus:border-2 focus:outline-none rounded-sm mt-5"
            placeholder="Password"
            {...register("password", {
              required: {
                message: "Password Is Required!",
              },
            })}
          />
          {errors?.password?.message && (
            <p className="text-red-600 self-start">
              {errors.password.message}!
            </p>
          )}

          <input
            type="submit"
            value="Log in"
            className="btn btn-block  focus:outline-none rounded-sm mt-5"
          />
        </form>
        <Link to="forgot-pass" className="text-blue-500 mt-5 block text-center">
          Forgot Password?{" "}
        </Link>
        <p className="mt-5">
          Already Have An Account?
          <Link
            to="/register"
            className="text-blue-500 hover:underline ml-2 text-left"
          >
            Sign up
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Index;
